<script>
import { useCounterStore } from '@/stores/counter';
import axios from 'axios';


export default{
    //data is a function that returns an object that takes in variables
data(){
   return{
        email:'',
        password:'',
        username:'',
        allusers:[],
        msg:'',
        counter:useCounterStore()
   }
   
},
mounted(){
this.allusers=JSON.parse(localStorage.getItem('allsignupusers')) || []
console.log(this.allusers);

},
methods:{
   handleLogin(){
    let user={
        // access:Math.random()*1000000+'/honeywealth',
        email:this.email,
        password:this.password
    }
    axios.post('http://127.0.0.1:8000/api/createlogin',user)
    .then((res)=>{
console.log(res.data);
if(res.data.status=='206'){
    
    this.counter.getprofile(res.data.profilepicture)
    localStorage.setItem('honeyuserid',JSON.stringify(res.data.userid))
     localStorage.setItem('honeyfullname',JSON.stringify(res.data.fullname))
     localStorage.setItem('honeyprofilepicture',JSON.stringify(res.data.profilepicture))
// this.$router.push({name:'dashboard',params:{id:res.data.student.student_id}})
this.$router.push('/panel')
}

    })
    .catch((err)=>{
        console.log(err);
        
    })
//     let user=this.allusers.find((user)=>user.username===this.username && user.password===this.password)
//     if(user){
//         // this.$router.push({name:'dashboard',params:{id:user.username}})
//         this.$router.push({name:'dashboard',params:{id:user.username}})
//         // console.log(user);
        
//     }
//     else{
//    this.msg='user not found';
    
//     }
//     setTimeout(() => {
//         this.msg=''
//     }, 3000);
    // console.log(this.email, this.password);
    
    // alert('working')
   } 
}
}
</script>

<template>
    <!-- <div>{{ counter.count }}</div> -->
    <!-- <router-link :to="{name:'blogs',params:{id:blog.blog_id,title:blog.title}}" >Read more.....</router-link> -->
    <div>
        <input type="text" class="form-control my-2" placeholder="Enter email" v-model.trim="email">
        <input type="text" class="form-control my-2" placeholder="Password" v-model.trim="password">
        <button class="btn btn-outline-primary" @click="handleLogin">Log In</button>
        
    </div>
    <div>
        
    </div>
    <p>{{msg}}</p>
</template>